import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { Router } from '@angular/router';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';

@Component({
  selector: 'news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  
  public breadcrumb = [];

  constructor(
    public lang:LangService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    this.breadcrumb = [
      this.breadcrumbsService.APPLICANT_LANDING(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_news'), this.router.url),
    ];
  }

}
